import { render, staticRenderFns } from "./select-widget.vue?vue&type=template&id=5217b364&scoped=true&"
import script from "./select-widget.vue?vue&type=script&lang=js&"
export * from "./select-widget.vue?vue&type=script&lang=js&"
import style0 from "./select-widget.vue?vue&type=style&index=0&id=5217b364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217b364",
  null
  
)

export default component.exports